import { VENUES_TAXONOMY_KEY } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { CategoryTiles } from '@zola/zola-ui/src/components/PreAuthV3';
import { StyledH3 } from '@zola/zola-ui/src/components/PreAuthV3/CategoryTiles.styles';
import { useResponsiveDesign } from '@zola/zola-ui/src/contexts/ResponsiveDesignContext/ResponsiveDesignContext';
import { FONT } from '@zola/zola-ui/src/styles/emotion';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';

import styled from '@emotion/styled';

import AQUARIUMS from '~/assets/images/lp/style-aquariams.jpg';
import BANQUET_HALLS from '~/assets/images/lp/style-banquet-halls.jpg';
import BARNS from '~/assets/images/lp/style-barns.jpg';
import BEACHES from '~/assets/images/lp/style-beaches.jpg';
import COUNTRY_CLUBS from '~/assets/images/lp/style-country-clubs.jpg';
import HISTORIC_BUILDINGS from '~/assets/images/lp/style-historic-buildings.jpg';
import HOTELS from '~/assets/images/lp/style-hotels.jpg';
import INDOOR_SPACES from '~/assets/images/lp/style-indoor-spaces.jpg';
import INDUSTRIAL_SPACES from '~/assets/images/lp/style-industrial-spaces.jpg';
import LODGES from '~/assets/images/lp/style-lodges.jpg';
import MUSEUMS from '~/assets/images/lp/style-museums.jpg';
import OUTDOOR_SPACES from '~/assets/images/lp/style-outdoor-spaces.jpg';
import PARKS from '~/assets/images/lp/style-parks.jpg';
import RESTAURANTS from '~/assets/images/lp/style-restaurants.jpg';
import URBAN_LOCATIONS from '~/assets/images/lp/style-urban-locations.jpg';
import VINEYARDS from '~/assets/images/lp/style-vineyards.jpg';
import { useSearchedLocation } from '~/contexts/SearchContext';
import { getAssetImageUrl } from '~/util/imageUtils';
import vendorSearchUrl from '~/util/vendorSearchUrl';

const StyledCategoryTiles = styled(CategoryTiles)`
  ${StyledH3} {
    ${MEDIA_QUERY_V2.MOBILE} {
      ${FONT.textSizeUltraCompact(FONT.SIZE.LARGE)};
    }
  }
`;

const ByStyleCategoryCarousel = () => {
  const { isMobile, isTablet } = useResponsiveDesign();
  const { searchedLocation } = useSearchedLocation();
  return (
    <StyledCategoryTiles
      title="Reception venues by style"
      cta={{
        linkText: isMobile ? 'View all' : 'View all venues',
        href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug),
        displayAsButton: true,
      }}
      tileButtonTextTransform={false}
      square={isMobile || isTablet}
      categories={[
        {
          image: getAssetImageUrl(OUTDOOR_SPACES, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Outdoor spaces',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, [
            'outdoor-space',
            'covered-outdoor-space',
          ]),
        },
        {
          image: getAssetImageUrl(BARNS, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Barns',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, [
            'farms-barns-ranches',
          ]),
        },
        {
          image: getAssetImageUrl(HISTORIC_BUILDINGS, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Historic buildings',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, [
            'historic-estates-mansions',
          ]),
        },
        {
          image: getAssetImageUrl(VINEYARDS, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Vineyards',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, [
            'vineyards-wineries',
          ]),
        },
        {
          image: getAssetImageUrl(BANQUET_HALLS, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Banquet halls',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, [
            'ballrooms-banquet-halls',
          ]),
        },
        {
          image: getAssetImageUrl(HOTELS, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Hotels',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, [
            'hotels-inns-resorts',
          ]),
        },
        {
          image: getAssetImageUrl(INDOOR_SPACES, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Indoor spaces',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, ['indoor-space']),
        },
        {
          image: getAssetImageUrl(BEACHES, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Beaches',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, [
            'beaches-waterfronts',
          ]),
        },
        {
          image: getAssetImageUrl(COUNTRY_CLUBS, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Country clubs',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, [
            'golf-country-clubs',
          ]),
        },
        {
          image: getAssetImageUrl(INDUSTRIAL_SPACES, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Industrial spaces',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, [
            'industrial-buildings',
          ]),
        },
        {
          image: getAssetImageUrl(URBAN_LOCATIONS, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Urban locations',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, ['urban-locations']),
        },
        {
          image: getAssetImageUrl(MUSEUMS, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Museums',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, ['musuems-galleries']),
        },
        {
          image: getAssetImageUrl(PARKS, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Parks',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, ['parks-gardens']),
        },
        {
          image: getAssetImageUrl(RESTAURANTS, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Restaurants',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, [
            'restaurants-breweries',
          ]),
        },
        {
          image: getAssetImageUrl(LODGES, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Lodges',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, ['lodges-retreats']),
        },
        {
          image: getAssetImageUrl(AQUARIUMS, { width: 220, quality: 80 }),
          altText: '',
          linkText: 'Aquariums, zoos',
          href: vendorSearchUrl(VENUES_TAXONOMY_KEY, searchedLocation?.slug, ['aquariums-zoos']),
        },
      ]}
    />
  );
};

export default ByStyleCategoryCarousel;
